package net.gorillagroove.discovery

import net.gorillagroove.api.Api
import net.gorillagroove.util.GGLog.logError

object SpotifySearchService {

    @Throws(Throwable::class)
    suspend fun searchByArtist(artist: String): MetadataSearchResponse {
        require(artist.isNotBlank()) { "Artist must not be blank!" }

        return try {
            Api.get("search/spotify/artist/${artist.trim()}")
        } catch (e: Exception) {
            logError("Failed to search spotify with artist '$artist'!", e)
            throw e
        }
    }

    @Throws(Throwable::class)
    suspend fun autocompleteArtistName(partialName: String): AutocompleteResult {
        require(partialName.isNotBlank()) { "Artist must not be blank!" }

        return try {
            Api.get("search/autocomplete/spotify/artist-name/${partialName.trim()}")
        } catch (e: Exception) {
            logError("Failed to search Spotify autocomplete!", e)
            throw e
        }
    }
}
